module.exports = __webpack_public_path__ + "static/media/pessoas-conversando-apertando-maos.4bef7991.svg";